import { ButtonBackStyled, IconStyled, PlaceholderStyled } from './styled';

type ButtonBackProps = {
  onBack?: () => void;
  hasPrevPath: boolean;
};

export const ButtonBack = ({ onBack, hasPrevPath }: ButtonBackProps) => {
  if (!hasPrevPath) return <PlaceholderStyled />;

  return (
    <ButtonBackStyled onClick={onBack} aria-label="Go Previous Screen Button">
      <IconStyled name="ic-chevron-left" />
    </ButtonBackStyled>
  );
};
